module.exports = __webpack_public_path__ + "img/ccompany-honor-VOC-20230309.5a9a4ab8.jpg";